import { toIdString } from "./id";
import { request } from "./request";

function toTrimmedString(value) {
  return String(value ?? "").trim();
}

export function fetchChairList(data) {
  return request("/order/fetchChairList", {
    method: "POST",
    body: {
      hospitalId: toIdString(data.hospitalId),
      projectId: toIdString(data.projectId),
      appointmentDate: toTrimmedString(data.appointmentDate),
      timeSlot: toTrimmedString(data.timeSlot),
    },
  });
}

export function createOrder(data) {
  return request("/order/createOrder", {
    method: "POST",
    body: {
      hospitalId: toIdString(data.hospitalId),
      hospitalCode: toTrimmedString(data.hospitalCode),
      hospitalName: toTrimmedString(data.hospitalName),
      doctorId: toIdString(data.doctorId),
      doctorName: toTrimmedString(data.doctorName),
      chairId: toIdString(data.chairId),
      chairName: toTrimmedString(data.chairName),
      workerId: toTrimmedString(data.workerId),
      patientName: toTrimmedString(data.patientName),
      projectId: toIdString(data.projectId),
      projectCode: toTrimmedString(data.projectCode),
      projectName: toTrimmedString(data.projectName),
      repairName: toTrimmedString(data.repairName),
      toothPosition: toTrimmedString(data.toothPosition),
      appointmentDate: toTrimmedString(data.appointmentDate),
      timeSlot: toTrimmedString(data.timeSlot),
      email: toTrimmedString(data.email),
      remark: toTrimmedString(data.remark),
    },
  });
}

/** 待办订单列表 POST /appointment/order/listOrders */
export function listOrders(data) {
  return request("/order/listOrders", {
    method: "POST",
    body: {
      status: Number(data.status),
      pageNum: Number(data.pageNum) || 1,
      pageSize: Number(data.pageSize) || 10,
    },
  });
}

/** 待办统计 POST /appointment/order/getTodoStats */
export function getTodoStats() {
  return request("/order/getTodoStats", {
    method: "POST",
    body: {},
  });
}

/** 订单详情 POST /appointment/order/getOrderDetail */
export function getOrderDetail(data) {
  return request("/order/getOrderDetail", {
    method: "POST",
    body: {
      orderId: toIdString(data.orderId),
    },
  });
}

/** 修改订单 POST /appointment/order/updateOrder */
export function updateOrder(data) {
  return request("/order/updateOrder", {
    method: "POST",
    body: {
      orderId: toIdString(data.orderId),
      hospitalId: toIdString(data.hospitalId),
      hospitalCode: toTrimmedString(data.hospitalCode),
      hospitalName: toTrimmedString(data.hospitalName),
      doctorId: toIdString(data.doctorId),
      doctorName: toTrimmedString(data.doctorName),
      chairId: toIdString(data.chairId),
      chairName: toTrimmedString(data.chairName),
      workerId: toTrimmedString(data.workerId),
      patientName: toTrimmedString(data.patientName),
      projectId: toIdString(data.projectId),
      projectCode: toTrimmedString(data.projectCode),
      projectName: toTrimmedString(data.projectName),
      repairName: toTrimmedString(data.repairName),
      toothPosition: toTrimmedString(data.toothPosition),
      appointmentDate: toTrimmedString(data.appointmentDate),
      timeSlot: toTrimmedString(data.timeSlot),
      email: toTrimmedString(data.email),
      remark: toTrimmedString(data.remark),
    },
  });
}

/** 确认预约 POST /appointment/order/confirmOrder */
export function confirmOrder(data) {
  return request("/order/confirmOrder", {
    method: "POST",
    body: {
      orderId: toIdString(data.orderId),
    },
  });
}

/** 确认退单 POST /appointment/order/confirmReturnOrder */
export function confirmReturnOrder(data) {
  return request("/order/confirmReturnOrder", {
    method: "POST",
    body: {
      orderId: toIdString(data.orderId),
    },
  });
}

/** 申请退单 POST /appointment/order/applyReturnOrder */
export function applyReturnOrder(data) {
  return request("/order/applyReturnOrder", {
    method: "POST",
    body: {
      orderId: toIdString(data.orderId),
      cancelReason: toTrimmedString(data.cancelReason),
      cancelReasonDetail: toTrimmedString(data.cancelReasonDetail),
    },
  });
}

/** 重新预约 POST /appointment/order/rescheduleOrder */
export function rescheduleOrder(data) {
  return request("/order/rescheduleOrder", {
    method: "POST",
    body: {
      orderId: toIdString(data.orderId),
      chairId: toIdString(data.chairId),
      chairName: toTrimmedString(data.chairName),
      workerId: toTrimmedString(data.workerId),
      projectId: toIdString(data.projectId),
      projectCode: toTrimmedString(data.projectCode),
      projectName: toTrimmedString(data.projectName),
      appointmentDate: toTrimmedString(data.appointmentDate),
      timeSlot: toTrimmedString(data.timeSlot),
    },
  });
}

/** 全部订单列表 POST /appointment/order/listAllOrders */
export function listAllOrders(data) {
  return request("/order/listAllOrders", {
    method: "POST",
    body: {
      pageNum: Number(data.pageNum) || 1,
      pageSize: Number(data.pageSize) || 10,
      orderNo: toTrimmedString(data.orderNo),
      projectName: toTrimmedString(data.projectName),
      chairName: toTrimmedString(data.chairName),
      hospitalName: toTrimmedString(data.hospitalName),
      doctorName: toTrimmedString(data.doctorName),
      status:
        data.status === "" || data.status == null || data.status === undefined
          ? null
          : Number(data.status),
    },
  });
}
